export var TRIGGER_CLICK_KEY_CODES = ['Enter', 'Space', ' '];